import { render } from "./edit.vue?vue&type=template&id=3905d4ae&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=3905d4ae&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3905d4ae"],['__file',"src/views/modelSetting/modelTask/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3905d4ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3905d4ae', __exports__)) {
    console.log('reload')
    api.reload('3905d4ae', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=3905d4ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('3905d4ae', render)
  })

}


export default __exports__